import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nPipe } from '@delon/theme';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { finalize } from 'rxjs';
import { HttpService } from 'src/app/http/http.service';
import { ImageService } from 'src/app/services/image.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { ConstantUtil } from 'src/app/util/constant.util';

import { ServiceBusinessCardComponent } from '../../servicenumber/detail/business-card/servicenumber-businesscard.component';

@Component({
  selector: 'personal-business-card-setting',
  standalone: true,
  imports: [CommonModule, NzSpinModule, NzCardModule, I18nPipe, ServiceBusinessCardComponent, TestIdDirective],
  templateUrl: './personal-business-card-setting.component.html',
  styleUrls: ['./personal-business-card-setting.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalBusinessCardSettingComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly http = inject(HttpService);
  private readonly imageService = inject(ImageService);

  loading = false;
  tenantId: string = '';

  serviceNumberId: string = '';
  avatarUrl: string = '';

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.tenantId = params.get('id') ?? '';
      this.serviceNumberId = localStorage.getItem('current_tenant_boss_snid') ?? '';
      if (this.serviceNumberId) {
        this.loadServiceAvatar();
      }
      this.cdr.detectChanges();
    });
  }

  private loadServiceAvatar(): void {
    this.loading = true;
    this.http
      .post(`${ConstantUtil.ADMIN_SERVICENUMBER_DETAIL}/${this.serviceNumberId}`, {})
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: res => {
          if (res?.success) {
            const data = res?.data?.serviceNumberModel ?? res?.data ?? {};
            const avatarId = data?.avatarId;
            if (avatarId) {
              this.imageService
                .loadImage(avatarId, 'M')
                .pipe(
                  finalize(() => {
                    this.cdr.detectChanges();
                  })
                )
                .subscribe(url => {
                  this.avatarUrl = url || '';
                  this.cdr.detectChanges();
                });
            } else {
              this.avatarUrl = '';
            }
          }
        },
        error: () => {
          this.avatarUrl = '';
          this.cdr.detectChanges();
        }
      });
  }
}
